import { Component, EventEmitter, input, Input, Output } from '@angular/core';
import { TableParent } from '../parent/table-parent';
import { DatePipe } from '@angular/common';
import { Task } from '../../domain/task';
import { Router } from '@angular/router';
import { TaskUtils } from '../../util/task-utils';
import { Property } from '../../domain/property';
import { PropertyStoreService } from '../../services/stores/property-store.service';
import { forkJoin, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ModelSummary } from '../../domain/Ai/model-summary';
import { PhobosTaskInstanceService } from '../../services/phobos-task-instance.service';

@Component({
   selector: 'app-day-task-table',
   templateUrl: './day-task-table.component.html',
   styleUrls: ['./day-task-table.component.scss']
})
export class DayTaskTableComponent extends TableParent {
   selectedTasks: Task | undefined;

   private _taskList: Task[] = [];

   @Input() set taskList(value: Task[]) {
      this._taskList = value ?? [];

      if (!this._taskList.length) return;

      const calls = this._taskList.map((t) =>
         this.taskInstanceService
            .getTaskAi(t.processId)
            .pipe(catchError(() => of(null)))
      );

      forkJoin(calls).subscribe((aiArray: (ModelSummary | null)[]) => {
         aiArray.forEach((ai, i) => {
            const task = this._taskList[i];

            if (!ai) {
               task.isAIEnabled = false;
               return;
            }
            task.isAIEnabled = true;
            task.isAutoCompleted = ai.isAutoCompleted;
            task.isValid = ai.isValid;
            task.isAtRisk =
               Array.isArray(ai.summaryData) && ai.summaryData.length > 0;
            task.isFinancialRisk = ai.isFinancial;
            if (ai.isValid) {
               if (ai.isAutoCompleted) {
                  task.aiStatus = 3;
               } else {
                  task.aiStatus = 2;
               }
            } else {
               task.aiStatus = 1;
            }
         });
      });
   }

   showDueDate = input(Boolean);
   @Output() dateChange: EventEmitter<number> = new EventEmitter();

   private selectedProperty: Property | undefined;

   constructor(
      datePipe: DatePipe,
      private router: Router,
      private propStore: PropertyStoreService,
      private taskInstanceService: PhobosTaskInstanceService
   ) {
      super(datePipe);
      this.propStore.currentProperty.subscribe((value) => {
         this.selectedProperty = value;
      });
      this.taskList = [];
   }

   get taskList(): Task[] {
      return this._taskList;
   }
   get isPhobosEnabled(): boolean {
      return this.selectedProperty?.isPhobosEnabled ?? false;
   }

   async goToTask(taskData: Task, $event: MouseEvent): Promise<void> {
      if (this.selectedProperty) {
         $event.preventDefault();
         await TaskUtils.goToTask(taskData, this.router, this.selectedProperty);
      }
   }
}
